import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

const Register = () => {
  const [formData, setFormData] = useState({ username: '', name: '', email: '', password: '' });
  const [error, setError] = useState('');
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await register(formData);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.detail || 'Registration failed');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-4" dir="rtl">
      <div className="bg-white p-8 rounded-3xl shadow-xl w-full max-w-md">
        <h2 className="text-2xl font-bold text-slate-800 mb-6 text-center">ثبت نام</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <input name="username" placeholder="نام کاربری" onChange={handleChange} className="w-full px-4 py-3 border rounded-xl" required />
          <input name="name" placeholder="نام کامل" onChange={handleChange} className="w-full px-4 py-3 border rounded-xl" required />
          <input name="email" type="email" placeholder="ایمیل" onChange={handleChange} className="w-full px-4 py-3 border rounded-xl" required />
          <input name="password" type="password" placeholder="رمز عبور" onChange={handleChange} className="w-full px-4 py-3 border rounded-xl" required />
          {error && <div className="text-rose-500 text-sm">{error}</div>}
          <button type="submit" className="w-full py-3 bg-indigo-600 text-white font-bold rounded-xl hover:bg-indigo-700">
            ثبت نام
          </button>
        </form>
        <p className="text-center text-sm text-slate-500 mt-4">
          قبلاً ثبت نام کرده‌اید؟ <a href="/login" className="text-indigo-600">ورود</a>
        </p>
      </div>
    </div>
  );
};

export default Register;